var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageAccountIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 21.6716V19.6096C20 18.5159 19.5786 17.4669 18.8284 16.6935C18.0783 15.9201 17.0609 15.4857 16 15.4857H8C6.93913 15.4857 5.92172 15.9201 5.17157 16.6935C4.42143 17.4669 4 18.5159 4 19.6096V21.6716",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.3617C14.2091 11.3617 16 9.51534 16 7.23774C16 4.96014 14.2091 3.11378 12 3.11378C9.79086 3.11378 8 4.96014 8 7.23774C8 9.51534 9.79086 11.3617 12 11.3617Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageAccountIcon);
export default __webpack_public_path__ + "static/media/manage-account-icon.04d64772977c0c35865fff5dc7e7c4de.svg";
export { ForwardRef as ReactComponent };